import { BreadCrumbCard } from 'components'

interface BaseItem {
  breadcrumb?: string
  lv1Name?: string
  lv1_name?: string
  lv2Name?: string
  lv2_name?: string
  originalCodes?: string
  original_codes?: string
  color?: string
  name: string
  cycles?: Array<{ name: string; id: string }>
}

interface SkillStandardBreadcrumbProps {
  item: BaseItem
  showCyclesBadges?: boolean
  fullBreadCrumb?: boolean
}

const getLv1Name = (item: BaseItem): string =>
  item.lv1Name || item.lv1_name || ''

const getLv2Name = (item: BaseItem): string =>
  item.lv2Name || item.lv2_name || ''

const getOriginalCodes = (item: BaseItem): string =>
  item.originalCodes || item.original_codes || ''

const getColor = (item: BaseItem): string =>
  item.color || '#6c757d'

const getCycles = (item: BaseItem): Array<{ name: string; id: string }> =>
  item.cycles || []

const escapeRegex = (str: string): string =>
  str.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')

const cleanTrailingPunctuation = (str: string): string =>
  str.replace(/[.:;,]+$/, '').trim()

const buildCompleteBreadcrumb = (item: BaseItem): string => {
  const originalCodes = getOriginalCodes(item)
  const lv1Name = getLv1Name(item)
  const cleanName = cleanTrailingPunctuation(item.name)
  const nameWithCode = originalCodes ? `${originalCodes} - ${cleanName}` : cleanName

  let breadcrumb = item.breadcrumb

  if (breadcrumb) {
    breadcrumb = cleanTrailingPunctuation(breadcrumb)

    if (lv1Name && !breadcrumb.toLowerCase().startsWith(lv1Name.toLowerCase())) {
      breadcrumb = `${lv1Name} > ${breadcrumb}`
    }

    if (breadcrumb.toLowerCase().includes(cleanName.toLowerCase())) {
      if (originalCodes) {
        const escapedName = escapeRegex(cleanName)
        return breadcrumb.replace(new RegExp(`(^|>\\s*)${escapedName}`, 'i'), `$1${nameWithCode}`)
      }
      return breadcrumb
    }

    return `${breadcrumb} > ${nameWithCode}`
  }

  const lv2Name = getLv2Name(item)
  return `${lv1Name} > ${lv2Name} > ${nameWithCode}`
}

export const SkillStandardBreadcrumb = ({
  item,
  showCyclesBadges = true,
  fullBreadCrumb = true
}: SkillStandardBreadcrumbProps) => {
  return (
    <BreadCrumbCard
      showCyclesBadges={showCyclesBadges}
      cycles={getCycles(item)}
      breadcrumb={buildCompleteBreadcrumb(item)}
      color={getColor(item)}
      fullBreadCrumb={fullBreadCrumb}
    />
  )
}
